import type { ServiceLinkItem } from '@root/src/server/types';

import createLink from './create-link';

export default function createListItemReducer(
  acc: HTMLLIElement[],
  { name, hasAccess = false, ...rest }: ServiceLinkItem,
  appendUrlParams = false,
) {
  const listItem = document.createElement('li');
  listItem.appendChild(
    createLink({
      isSubscribed: hasAccess,
      text: name,
      appendUrlParams,
      ...rest,
    }),
  );

  return [...acc, listItem];
}
